import axios from "axios";
import { TokenService } from "./auth/storage.services";

const ApiService = {
  init(baseURL) {
    axios.defaults.baseURL = baseURL;
  },

  setHeader() {
    axios.defaults.headers.common.Authorization = `Bearer ${TokenService.getToken()}`;
    axios.defaults.headers.common["Content-Type"] =
      "application/json; charset=UTF-8";
    axios.defaults.headers.common["Access-Control-Allow-Origin"] = "*";
  },
  removeHeader() {
    axios.defaults.headers.common = {};
  },

  get(resource) {
    return new Promise((resolve, reject) => {
      axios
        .get(resource)
        .then(function(response) {
          resolve(response);
        })
        .catch(function(error) {
          if (error.response) reject(error.response);
          else reject(error);
        });
    });
  },

  post(resource, data, headers) {
    return new Promise((resolve, reject) => {
      axios
        .post(resource, data, { headers: headers })
        .then(function(response) {
          resolve(response);
        })
        .catch(function(error) {
          if (error.response) reject(error.response);
          else reject(error);
        });
    });
  },

  put(resource, data, headers) {
    return new Promise((resolve, reject) => {
      axios
        .put(resource, data, { headers: headers })
        .then(function(response) {
          resolve(response);
        })
        .catch(function(error) {
          if (error.response) reject(error.response);
          else reject(error);
        });
    });
  },

  patch(resource, data) {
    return new Promise((resolve, reject) => {
      axios
        .patch(resource, data)
        .then(function(response) {
          resolve(response);
        })
        .catch(function(error) {
          if (error.response) reject(error.response);
          else reject(error);
        });
    });
  },
  delete(resource, data) {
    return new Promise((resolve, reject) => {
      axios
        .delete(resource, { data })
        .then(function(response) {
          resolve(response);
        })
        .catch(function(error) {
          if (error.response) reject(error.response);
          else reject(error);
        });
    });
  },

  customRequest(data) {
    return axios(data);
  }
};

export default ApiService;
